import { render, staticRenderFns } from "./Unfold.vue?vue&type=template&id=f8de3f48&scoped=true"
import script from "./Unfold.vue?vue&type=script&lang=js"
export * from "./Unfold.vue?vue&type=script&lang=js"
import style0 from "./Unfold.vue?vue&type=style&index=0&id=f8de3f48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8de3f48",
  null
  
)

export default component.exports